<div id="issue_actions">
  <h4>
    <button (click)="noteAction()" class="action_button">Add Note</button>
    <button (click)="deferAction()" class="action_button">Defer</button>
    <button (click)="resolveAction()" class="action_button">Resolve</button>
    <button (click)="resolveDuplicateAction()" class="action_button">Duplicate</button>
    <button (click)="escalateAction()" class="action_button">Escalate</button>
  </h4>
  <ul class="issue_actions">
    <li id="new_action">
      <span class="action_took">
        <label for="took_minutes" class="for">action took: </label>
        <input id="took_minutes" [(ngModel)]="action_took_minutes" placeholder="minutes" class="took_minutes" type="number" pattern="[0-9]*"/>
      </span>
      <ng-container *ngIf="current_action === 'note'">
        <label for="note_action_type" class="for">action types: </label>
        <select [(ngModel)]="note_action.action_type" id="note_action_type">
          <option *ngFor="let action_type of action_types" [value]="action_type.action_type_id">{{action_type.action_type_text}}</option>
        </select>
        <label for="issue_status" class="for">issue status: </label>
        <select class="form-control"  id="issue_status" [(ngModel)]="note_issue_status" id="note_issue_status">
          <option *ngFor="let status of issue_statuses" [value]="status.issue_status_id">{{status.issue_status_text}}</option>
        </select><br />
        <textarea [(ngModel)]="note_action.action_text" placeholder="What happened..." rows="4" class="input_action_text"></textarea>
        <button (click)="saveNote()" class="save">Save</button>
      </ng-container>
      <ng-container *ngIf="current_action === 'resolve'"><br />
        <textarea [(ngModel)]="resolve_action.action_text" placeholder="What did you do..." rows="4" class="input_action_text"></textarea>
        <button (click)="saveResolution()" class="save">Save</button>
      </ng-container>
        <ng-container *ngIf="current_action === 'duplicate'"><br />
        <textarea [(ngModel)]="resolve_action.action_text" placeholder="Duplicate..." rows="4" class="input_action_text"></textarea>
        <button (click)="saveDuplicateResolution()" class="save">Save</button>
      </ng-container>
      <ng-container *ngIf="current_action === 'defer'">
        <label class="for">next action due: </label>
        <input [(ngModel)]="deferred_action_due" placeholder="Defer until..." class="action_due"/><br />
        <textarea [(ngModel)]="defer_action.action_text" placeholder="Why are you deferring this..." rows="4" class="input_action_text"></textarea>
        <button (click)="saveDeferrment()" class="save">Save</button>
      </ng-container>
      <ng-container *ngIf="current_action === 'escalate'">
        <label class="for">next action due: </label>
        <input [(ngModel)]="escalate_action_due" placeholder="Defer until..." class="action_due"/><br />
        <textarea [(ngModel)]="escalate_action.action_text" placeholder="Escalating this because..." rows="4" class="input_action_text"></textarea>
        <button (click)="saveEscalation()" class="save">Save</button>
      </ng-container>
    </li>
    <ng-container *ngIf="actions; else loading">
      <ng-container *ngIf="actions.length; else noactions">
        <li>
          <span class="occurred">Occurred</span>
          <span class="action_type">Action Type</span>
          <span class="action_text">Action</span>
          <span class="took_minutes">Took</span>
          <span class="action_by">By</span>
        </li>
        <li *ngFor="let action of actions"
            [style.background-color]="this.getColorFor(action)">
          <span class="occurred">{{action.occurred | godate}}</span>
          <span class="action_type">{{action.type_text}}</span>
          <span class="action_text">{{action.action_text}}</span>
          <span class="took_minutes">{{action.took_minutes}}</span>
          <span class="action_by">{{action.action_by}}</span>
        </li>
      </ng-container>
      <ng-template #noactions>No actions yet!</ng-template>
    </ng-container>
    <ng-template #loading>Fetching actions...</ng-template>
  </ul>
</div>
